import { Box, Flex } from '@chakra-ui/core'
import React, { useEffect } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import FrequencyDatesPicker from './FrequencyDatesPicker'
import { StepType, useFormStepContext } from '../../FormStepContext'
import { FormContext, useForm, useFormContext } from 'react-hook-form'
import DeadLineDatePicker from './DeadlineWidget'
import ReviewDeadlineWidget from './ReviewDeadlineWidget'
import StartDatePicker from './StartDateWidget'
import dayjs from 'dayjs'
import { FrequencyMenu } from './FrequencyMenu'
import { RecurringSwitch } from './RecurringSwitch'
import { AllowedOverdueDays } from './AllowedOverdueDays'
import { DEFAULT_ALLOWED_OVERDUE_DAYS } from '../../utils'

const TimeFrameSelection = () => {
  const { setCurrentFormSubmit, updateFormData, formData, goToPreviousStep } = useFormStepContext()

  const defaultValues = formData[StepType.TIME_FRAME_SELECTION] || {
    from_ts: dayjs().toISOString(),
    deadline: dayjs(dayjs()).add(8, 'hour').toISOString(),
    frequency_time: '',
    monthly_range: [],
    is_recurring: false,
    days_of_week: null,
    recurrence_frequency: null,
    allowed_overdue_days: DEFAULT_ALLOWED_OVERDUE_DAYS,
    review_to_ts: null,
  }

  const methods = useForm({
    defaultValues,
    mode: 'onChange',
  })

  const { handleSubmit } = methods

  useEffect(() => {
    setCurrentFormSubmit(() =>
      handleSubmit((data) => {
        updateFormData(StepType.TIME_FRAME_SELECTION, data)
        goToPreviousStep()
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FormContext {...methods}>
      <TimeFrameFields />
    </FormContext>
  )
}

export default TimeFrameSelection

/** Shared fields: the legacy step and the inline settings editor use the same validation. */
export const TimeFrameFields = ({ showReviewDeadline = true }: { showReviewDeadline?: boolean }) => {
  const { watch } = useFormContext()

  const isRecurring = watch('is_recurring')

  return (
    <Flex flexDir="column">
      <Flex w="100%" justifyContent="center" my="30px">
        <RecurringSwitch />
      </Flex>

      <Flex flexDir="column">
        <StartDatePicker />

        <Flex flexDir="column" style={{ rowGap: '10px' }} my={!isRecurring ? '15px' : '45px'}>
          <FrequencyMenu />
          <FrequencyDatesPicker />
        </Flex>
        <Box>
          <DeadLineDatePicker />

          <Box mt="40px">
            <AllowedOverdueDays />
          </Box>

          {!isRecurring && showReviewDeadline && (
            <Box mt="40px">
              <ReviewDeadlineWidget />
            </Box>
          )}
        </Box>
      </Flex>
    </Flex>
  )
}
